module.exports = __webpack_public_path__ + "img/sii-imagotipo.620915a5.svg";